export default __webpack_public_path__ + "static/media/cmaAds@2x.057ff89f.jpg";